// The design system's System/Finder-Stroke, byte copy of adriel-fe-react
// assets/iconsV2/System_Finder-Stroke.svg. Both icons pass their own viewBox:
// svgo drops a viewBox that matches width/height, and `v-view-box` would set
// 0 0 24 24, which shrinks a 20px (Finder) or 16px (clear) drawing and pins it
// to the top-left of its slot.
import FinderIcon from '@svgIcons/system-finder-stroke.svg';
import CircleCloseFillIcon from '@svgIcons/circle-close-fill.svg';
import { Wrapper, SearchInput } from './SearchInput.styled';

/**
 * The product's one search field (TASK-14078), mirroring the React app's
 * `shared/ui/SearchInput`: the design system's Finder icon tinted on focus, clear button while
 * there is a value. `iconAlign` is accepted for backwards compatibility but
 * the icon always sits on the left now.
 */
export default {
    name: 'SearchInput',
    props: {
        value: {
            type: [String, Number],
            default: '',
        },
        placeholder: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        iconAlign: {
            type: String,
            default: 'left',
        },
        autofocus: {
            type: Boolean,
            default: false,
        },
        clearable: {
            type: Boolean,
            default: true,
        },
        identifier: String,
    },
    methods: {
        clear(e) {
            // The button unmounts once the value empties; stop the click here so
            // window-level outside-click checks don't see a detached target.
            e && e.stopPropagation();
            this.$emit('input', '');
            this.$emit('clear');
            const input = this.$el && this.$el.querySelector('input');
            input && input.focus();
        },
    },
    render() {
        const {
            value,
            inputEmitter,
            placeholder,
            disabled,
            autofocus,
            identifier,
            clearable,
        } = this;
        const showClear = clearable && value !== '' && value != null && !disabled;
        return (
            <Wrapper class="search-input">
                <FinderIcon class="search-icon" viewBox="0 0 20 20" />
                <SearchInput
                    value={value}
                    onInput={inputEmitter}
                    placeholder={placeholder}
                    disabled={disabled}
                    autofocus={autofocus}
                    identifier={identifier}
                />
                {showClear && (
                    <button
                        type="button"
                        class="clear-button"
                        aria-label={this.$t('COMMON.clear')}
                        onMousedown={(e) => e.preventDefault()}
                        onClick={this.clear}
                    >
                        <CircleCloseFillIcon viewBox="0 0 16 16" />
                    </button>
                )}
            </Wrapper>
        );
    },
};
